import React from 'react';
import {
  ActivityCodeChip,
  ActivityEntry
} from './activity-entry';
import './styles/index.scss';
const userActivityCommentFormatter = (
  activity: CMxAPI.UserActivityComment
): any => (
  <ActivityEntry
    timestamp={activity.timestamp}
    actor={activity?.username ?? ''}
    primary={
      <>
        Comment added{' '}
        <ActivityCodeChip>{activity.message}</ActivityCodeChip>
      </>
    }
  />
);

const cqaUserActivityFormatter = (activity: CQA.CQAComment): any => (
  <ActivityEntry
    timestamp={activity.timestamp}
    actor={activity.coder_username}
    primary={
      <>
        {activity.activityType === 'CQA_FEEDBACK_COMMENT' ? "Feedback added by" : 'Comment added by'}{' '}
        <ActivityCodeChip>{activity?.coder_fullName}</ActivityCodeChip>
        {': '}
        <ActivityCodeChip>{activity.note_content}</ActivityCodeChip>
      </>
    }
  />
);

export { cqaUserActivityFormatter, userActivityCommentFormatter };
